/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Nodedeleted1Inputs */

const zh_course_nodedeleted1 = /** @type {(inputs: Course_Nodedeleted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`节点已删除`)
};

const en_course_nodedeleted1 = /** @type {(inputs: Course_Nodedeleted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Node deleted`)
};

const es_course_nodedeleted1 = /** @type {(inputs: Course_Nodedeleted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nodo eliminado`)
};

/**
* | output |
* | --- |
* | "Node deleted" |
*
* @param {Course_Nodedeleted1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const course_nodedeleted1 = /** @type {((inputs?: Course_Nodedeleted1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Nodedeleted1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_nodedeleted1(inputs)
	if (locale === "en") return en_course_nodedeleted1(inputs)
	return es_course_nodedeleted1(inputs)
});
export { course_nodedeleted1 as "course_nodeDeleted" }